<template>
    <div class="creditEvaluate">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="contentLeft">
                        <ul>
                            <li v-for="(item, index) in menuList" :key="index" :class="active == index ? 'active' : ''" @click="activeChange(item, index)">
                                <img src="../../assets/img/index/arrows4.png" alt="" v-if="active == index">
                                <div style="width: 12px;" v-else></div>
                                <span style="margin-left: 10px;">{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="contentRight">
                        <div class="top">
                            <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                            <div class="title3">
                                <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                            </div>
                        </div>
                        <div class="bottom" v-loading="loading">
                            <div v-html="detail.content"></div>
                            <!-- <ul>
                                <li v-for="(item, index) in rollList" :key="index">
                                    <div style="width: 6px;height: 20px;border-radius: 6px;background: linear-gradient(to bottom, #1A68E8, #fff);"></div>
                                    <div style="cursor: pointer;margin: 0 15px;">{{ item.title }}</div>
                                    <div><img src="../../assets/img/index/arrows5.png" alt=""></div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'creditEvaluate',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            menuList: [
                {
                    name: '企业信用评价活动通知',
                },
                {
                    name: '企业信用评价管理办法',
                },
                {
                    name: '企业信用评价工作流程',
                },
                {
                    name: '企业信用评价证书标牌',
                },
                {
                    name: '企业信用评价申请材料',
                },
            ],
            active: 0,
            activeName: '企业信用评价活动通知',
            detail: {},
            contentList: [],
            loading: false
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.getContent()
    },
    mounted() {
    },
    methods: {
        // 获取信息
        getContent() {
            let _this = this
            _this.loading = true
            _this.detail = {}
            let params = {}
            api.getCreditEvaluationList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    // data.data.forEach(element => {
                    //     if (element.cateId == 14) {
                    //         _this.detail = element
                    //     }
                    // });
                    _this.contentList = data.data
                    if (this.$route.query.activeItem == undefined) {
                        let obj = {
                            name: '企业信用评价活动通知'
                        }
                        _this.activeChange(obj, _this.$route.query.active)
                    } else {
                        _this.activeChange(JSON.parse(_this.$route.query.activeItem), _this.$route.query.active)
                    }
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
                _this.loading = false
            //   _this.$toast('网络错误，请检查网络')
            })
            
        },


        // 切换菜单
        activeChange(item, index) {
            let _this = this
            // console.log(item, index);
            this.active = index
            this.activeName = item.name
            _this.detail = {}
            if (index == 0) {
                _this.contentList.forEach(element => {
                    if (element.cateId == 14) {
                        _this.detail = element
                    }
                });
            } else if (index == 1) {
                _this.contentList.forEach(element => {
                    if (element.cateId == 15) {
                        _this.detail.content = element.content
                    }
                });
            } else if (index == 2) {
                _this.contentList.forEach(element => {
                    if (element.cateId == 16) {
                        _this.detail = element
                    }
                });
            } else if (index == 3) {
                _this.contentList.forEach(element => {
                    if (element.cateId == 17) {
                        _this.detail = element
                    }
                });
            } else if (index == 4) {
                _this.contentList.forEach(element => {
                    if (element.cateId == 18) {
                        _this.detail = element
                    }
                });
            }
        }
    }
}
</script>

<style lang="less" scoped>
.creditEvaluate {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .contentLeft {
                    width: 26%;
                    height: 230px;
                    li {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        padding: 0 15px;
                        height: 46px;
                        line-height: 46px;
                        font-size: 20px;
                        color: #666;
                        cursor: pointer;
                        border: 1px solid #D9D9D9;
                        img {
                            display: inline-block;
                        }
                    }
                    li:nth-of-type(n+2) {
                        border-top-color: #fff;
                    }
                    .active {
                        color: #1A68E8;
                        border: 1px solid #1A68E8;
                        border-top-color: #1A68E8 !important;
                    }
                }
                .contentRight {
                    width: 73%;
                    border: 1px solid #D9D9D9;
                    padding: 10px 30px;
                    .top {
                        height: 55px;
                        position: relative;
                        .titleBackground {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                        .title3 {
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: 15px;
                            display: flex;
                            align-items: center;
                            font-size: 26px;
                            font-weight: 700;
                            background: linear-gradient(to bottom, #005CF3, #134BA8);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
                        .more {
                            position: absolute;
                            right: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                            font-size: 18px;
                            color: #1A68E8;
                            cursor: pointer;
                        }
                    }
                    .bottom {
                        font-size: 22px;
                        color: #1A68E8;
                        margin-top: 30px;
                        li {
                            display: flex;
                            justify-content: left;
                            align-items: center;
                            padding: 15px 0;
                        }
                    }
                }
            }
        }
    }
}
</style>